import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import axios from 'axios';
import PropTypes from 'prop-types';
import {
    LOAD_QUOTE,
    UPDATE_QUANTITIES,
    SELECT_COMPULSORY_ITEMS,
    HIGHLIGHT_SUBMENU_ITEMS
} from '../redux/quote';
import Sidebar from '../components/Sidebar';
import Main from '../components/Main';
import QuoteIntro from '../components/QuoteIntro';
import moment from "moment";
import {updateCateringMinimumSpend} from "../redux/actions/rules";
import TagManager from 'react-gtm-module'
import Branding from "../components/Branding";
import RequestStatus from "../components/RequestStatus";
import { loadErrorMessage } from "../services/requests";


function Quote({ config, dispatch, selectedDate, currentMenu }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);
  const date = selectedDate.date || (config.startDate ? moment(config.startDate, 'DD-MM-YYYY') : moment());
  const dateKey = date.format('YYYY-MM-DD');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    axios.get(`${config.appUrl}/api/v2/menu/${config.key}/${dateKey}`)
      .then((response) => {
        if (!active) return;
        if (_.isEmpty(response.data.menu)) {
          setLoading(false);
          setError('There is no menu available for your date. Please retry or choose another date.');
          return;
        }
        dispatch({ type: LOAD_QUOTE, payload: response.data.menu, preserveSelections: true });
        dispatch({ type: HIGHLIGHT_SUBMENU_ITEMS });
        dispatch({ type: SELECT_COMPULSORY_ITEMS });
        dispatch({ type: UPDATE_QUANTITIES });
        dispatch(updateCateringMinimumSpend());
        setLoading(false);
      })
      .catch((error) => {
        if (!active) return;
        setLoading(false);
        setError(loadErrorMessage(error, 'the menu for your date') + ' Your existing selections are kept.');
      });
    return () => { active = false; };
  }, [config.appUrl, config.key, dateKey, retry, dispatch]);

  useEffect(() => {
    if (config.location.ga_tracking_code) {
      TagManager.initialize({ gtmId: config.location.ga_tracking_code });
    }
  }, [config.location.ga_tracking_code]);

  let logo = '/images/cordero.png';
  if (!_.isNull(config.location.logo_id)) {
      logo = `/quote/logo/location/${config.location.id}`;
  } else if (!_.isNull(config.company.logo_id)) {
      logo = `/quote/logo/${config.company.id}`
  }

    return (
        <>
            <Branding/>
            <div className="Quote" id={'quoteContainer'}>
                <div className="container-fluid g-0">
                    <header className="App-header">
                        <img src={config.appUrl + logo} alt={config.location.name + " logo"}/>
                    </header>
                </div>
                <div className={'container'}>
                    <div className={'row no-gutters'}>
                        <div className={'col-12 my-auto'}>

                        </div>
                    </div>
                    <QuoteIntro/>
                    <RequestStatus loading={loading} error={error} onRetry={() => setRetry(retry + 1)} />
                    {!loading && !error && !_.isEmpty(currentMenu) && <div className="row">
                        <div className={'col-md-8'}>
                            <Main/>
                        </div>
                        <div className={'col-md-4'}>
                            <Sidebar/>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    );
}
Quote.propTypes = {
  config: PropTypes.object,
  dispatch: PropTypes.func,
  selectedDate: PropTypes.object,
  currentMenu: PropTypes.object,
}

const mapStateToProps = function (state) {
  return {
    config: state.config,
    selectedDate: state.quote.selectedDate,
    currentMenu: state.quote.menu,
  };
};

export default connect(mapStateToProps)(Quote);
